<template>
  <div class="main-template">
    <v-snackbar
      v-if="successMessage"
      v-model="successMessage"
      :timeout="5000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <d-table
      tableName="packages"
      sortBy="order"
      :data_object="data_object"
      :getFreshData="true"
      addButtonCaption="Add Package"
      :linkClick="linkClick"
      :link="link"
      :editRow="true"
      :alwaysUpdate="true"
      :hasSearch="true"
      ref="dTable"
      :afterSave="afterSave"
      :key="tableKey"
    />
  </div>
</template>

<script>
import DTable from "../components/Table";
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "MoveraiPackage",
  components: { DTable },
  props: {},
  data() {
    return {
      data_object: {
        object_name: "moverai_package",

        // mobileBreakpoint: 0,
        all_records: true,
        qry: {},

        hasSearch: true
      },
      link: {
        field: "shipment_id",
        name: "shipment"
      },
      successMessage: "",
      tableKey: 0
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
    afterSave(tbl, model) {
      console.log(model);
      this.tableKey = !this.tableKey;
      axios
        .post(this.serverURL + "/sync_products", {
          package: model
        })
        .then(response => {
          console.log(response);
          this.successMessage = response.data;
        });
      //sync_products
    }
  }
};
</script>

<style lang="css" scoped></style>
